module.exports = __webpack_public_path__ + "static/media/scss.fcf40d6a.png";